import React from "react";
import classNames from "classnames";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "280px",
		marginBottom: "27px",
		marginLeft: "10px",
		marginRight: "10px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "300px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "230px",
			marginLeft: "5px",
			marginRight: "5px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			marginLeft: "0",
			marginRight: "0",
			marginBottom: "20px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
}));

const FiltersItem = React.memo(({ children, stub }) => {
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.root, {
				[classes.isStub]: stub,
			})}
		>
			{children}
		</div>
	);
});

export default FiltersItem;
